import React from 'react'
import Card from '../../components/Card'

export default function () {
	return (
		<div className="flex flex-col text-slate-800 sm:mx-4 sm:my-6 md:mx-32 md:my-12 leading-loose">
			<Card className="flex flex-col">
				<h1 className="text-slate-800 mb-4">Contatos</h1>

				<p>E-mail: <a href="mailto:suporte@positronictech.com.br">suporte@positronictech.com.br</a></p>
				<p>WhatsApp: <a href="https://bit.ly/prontuario-digital">(21) 97542-5732</a></p>
			</Card>
		</div>
	)
}
